import * as modalAction from './modal-action'

export {
  modalAction,
}



// WEBPACK FOOTER //
// ./src/actions/modal/index.js